/**
 * フォーム機能を管理するクラス
 * - 郵便番号検索
 * - メールアドレス確認
 * - 同意チェックの有効/無効制御
 * - バリデーションと送信制御
 */
export class Form {
	constructor() {
		// 各要素を取得
		this.$postCodeBtn = $('.js-post_code_search'); // 郵便番号検索ボタン
		this.$mailInput = $('.js-mail_check02');      // 確認用メール入力
		this.$consentCheck = $('.js-consent_check');  // 同意チェック
		this.$submitBtn = $('.js-submit_btn');        // 送信ボタン
		this.$form = $('.js-form');                   // フォーム本体

		// エラーメッセージ用要素を生成し、フォームの先頭に挿入
		this.$errorMessage = $('<div aria-live="polite" class="sr-only"></div>');
		this.$form.prepend(this.$errorMessage);

		this._init();
	}

	/**
	 * イベントハンドラを設定
	 * - 郵便番号検索
	 * - 同意チェック
	 * - フォーム送信
	 * @private
	 */
	_init() {
		this.$postCodeBtn.on('click', (e) => this._getPostCode(e));
		this.$consentCheck.on('change', () => this._toggleConsent());
		this.$form.on('submit', (e) => this._validateForm(e));
	}

	/**
	 * 郵便番号から住所を取得してフォームにセット
	 * @param {Event} e
	 * @private
	 */
	_getPostCode(e) {
		e.preventDefault();
		const postalCode = $('.js-post_code').val();
		if (postalCode) {
			const apiUrl = `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`;
			$.ajax({
				url: apiUrl,
				method: 'GET',
				success: (data) => {
					data = JSON.parse(data);
					$('.js-address').val(
						data.results[0].address1 +
						data.results[0].address2 +
						data.results[0].address3
					);
				},
				error: () => {
					this._showError('郵便番号の検索に失敗しました。');
				}
			});
		} else {
			this._showError('郵便番号を入力してください。');
		}
	}

	/**
	 * メールアドレスの確認
	 * @returns {boolean} 一致すれば true
	 * @private
	 */
	_mailDoubleCheck() {
		const mail1 = $('.js-mail_check01').val();
		const mail2 = $('.js-mail_check02').val();
		if (mail1 !== mail2) {
			this._showError('メールアドレスが一致しません。');
			$('.js-mail_check02').attr('aria-invalid', 'true').focus();
			return false;
		}
		$('.js-mail_check02').removeAttr('aria-invalid');
		return true;
	}

	/**
	 * 同意チェックに応じて送信ボタンの有効/無効を切り替え
	 * @private
	 */
	_toggleConsent() {
		const isChecked = this.$consentCheck.is(':checked');
		this.$submitBtn.prop('disabled', !isChecked);
	}

	/**
	 * フォーム送信時のバリデーション
	 * - 必須項目チェック
	 * - メール確認
	 * @param {Event} e
	 * @private
	 */
	_validateForm(e) {
		e.preventDefault();

		let isValid = true;
		let firstInvalidElement = null;

		// 必須項目のチェック
		this.$form.find('.js-required').each(function () {
			if (!$(this).val()) {
				isValid = false;
				$(this).attr('aria-invalid', 'true');
				if (!firstInvalidElement) firstInvalidElement = this;
			} else {
				$(this).removeAttr('aria-invalid');
			}
		});

		if (!isValid) {
			this._showError('入力されていない項目があります。');
			firstInvalidElement.focus();
			return;
		}

		// メール確認後に送信
		if (this._mailDoubleCheck()) {
			this.$form[0].submit();
		}
	}

	/**
	 * エラーメッセージの表示
	 * @param {string} message
	 * @private
	 */
	_showError(message) {
		this.$errorMessage.text(message);
		alert(message); // 視覚的ユーザー用に alert も表示
	}
}
